import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText, ScrollTrigger);
import leaflet from 'leaflet';
import indonesiaGeoJSON from '../../../../assets/js/indonesia-province-simple.json';



export function initWhereWeAreFrom() {
    mapInit();
    mapAnimation();
}


function mapAnimation(){
    const mapMarkerContainerElms=document.querySelectorAll(".map__marker-container")

    let markerHeight=80;


    if (window.innerWidth < 767) {
        markerHeight=50;
    }
    let mapTL = gsap.timeline({
        scrollTrigger: {
            trigger: '.where-our-vanilla__info-container',
            start: "bottom bottom",
            onEnter:function(){
                mapMarkerContainerElms.forEach((element, key) => {
                    gsap.to(element, {
                        height:markerHeight,
                        delay: key * 0.05,
                        duration: 0.7
                    })
                });
            }
        },
    });
    mapTL.fromTo(map, { autoAlpha: 0 }, { autoAlpha: 1 });
}

function mapInit(){
    const indonesiaMap = indonesiaGeoJSON;

    // add max bounds
    var southWest = L.latLng(8.761049185262605, 92.67377934576241),
    northEast = L.latLng(-13.090859714049843, 142.51525632284654),
    bounds = L.latLngBounds(southWest, northEast);

    let zoom, maxZoom;
    if (window.innerWidth > 1400) {
        zoom = 5;
        maxZoom = 5;
    }
    else if (window.innerWidth > 1024) {
        zoom = 4;
        maxZoom = 4;
    }
    else {
        zoom = 4;
        maxZoom = 4;
    }

    // init
    const map = L.map('map', {
        //center: [-2.569834, 118.165100],
        center: [0.790991, 100.942383],
        zoom: zoom,
        minZoom: maxZoom,
        maxZoom: 7,
        zoomControl: false,
        scrollWheelZoom: false,
        maxBounds: bounds,
    });

    // map zoom control
    L.control.zoom({
        position: 'bottomleft',
    }).addTo(map);

    // map background
    L.tileLayer('').addTo(map);

    // map style
    const style = {
        "color": "#839376",
        "weight": "1",
        "fillColor": "#839376",
        "fillOpacity": '1'
    };
    const indonesiaMapGeoJSON = L.geoJSON(indonesiaGeoJSON, {
        style: style,
    }).addTo(map);

    let popupGroup = L.layerGroup();
    popupGroup.addTo(map);

    // map pin
    const markerOptions = {
        data: [
            { 
                label: 'Sumatra Island',
                latLng: [1.559866, 99.580078]
            },
            { 
                label: 'Java Island',
                latLng: [-6.495441, 106.265259]
            },
            { 
                label: 'Bali Island',
                latLng: [-8.3963, 115.186844]
            },
            { 
                label: 'Lombok Island',
                latLng: [-8.552504, 116.328735],
                directionLabel:'bottom'
            },

            { 
                label: 'Flores Island',
                latLng: [-8.602747, 122.717285],
                directionLabel:'bottom'
            },

            { 
                label: 'Sulawesi Island',
                latLng: [-2.010086, 120.168457],
                
            },

            { 
                label: 'Papua Island',
                latLng: [-3.743671, 137.131348],
                
            },

            { 
                label: 'Maluku Island',
                latLng: [0.64818, 127.913818],
                
            },
        ],
    }

    markerOptions.data.forEach((marker) => {
        const customIcon = L.divIcon({
            className: 'map__marker',
            html: `<div class="map__marker-container ${marker.directionLabel}"><div class="map__marker-text">${marker.label}</div></div>`
        });
        L.marker(marker.latLng, { icon: customIcon }).addTo(map);
    });
}